export const buildTemporalWorkflowsUrlForAssetId = (
  temporalWebUiBaseUrl: string,
  assetId: string,
) => {
  const base = temporalWebUiBaseUrl.replace(/\/$/, '');
  const query = `\`AssetId\`="${assetId}"`;
  return `${base}/namespaces/default/workflows?query=${encodeURIComponent(query)}`;
};
